// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper_2mXmq","modal":"Modal_modal_2Vr-l","close_icon":"Modal_close_icon_LnXQV"};